import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import InventaireComponent from '../../../components/Mouvement/Panel/InventaireComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class InventairePanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.INVENTAIRE;
		this.defaultSize = 6;
		this.icon = { name: 'car' };
	}

	getLibelle = () => 'Inventaire';

	isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.actif);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<InventaireComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default InventairePanel;
